export default __webpack_public_path__ + "static/media/academy_2_1.8b9cd574.svg";